<script setup lang="ts">
import { computed, useSlots } from 'vue'
import { Dropdown as VDropdown } from 'floating-vue'
import SeatModal from './SeatModal.vue'

const props = withDefaults(
  defineProps<{
    popupPlacement: 'top' | 'bottom' | 'left' | 'right'
    avatarPlacement?: 'left' | 'right'
    viewMode?: 'mobile' | 'desktop'
  }>(),
  { viewMode: 'mobile', avatarPlacement: 'left' }
)

const handleShow = () => {
  setTimeout(() => {
    ;(
      document.querySelector('.v-popper__popper--shown input:not([disabled])') as HTMLInputElement
    )?.focus()
  }, 100)
}

const wrapper = computed(() => {
  const slots = useSlots()

  if (!slots.popper) {
    return 'div'
  }

  return props.viewMode === 'desktop' ? VDropdown : SeatModal
})
</script>

<template>
  <component
    :is="wrapper"
    class="seat-plate"
    :class="`seat-plate--${viewMode} seat-plate--${avatarPlacement}`"
    :placement="popupPlacement"
    @apply-show="handleShow"
  >
    <div class="seat-plate__content" :class="`seat-plate__content--${viewMode}`" role="button">
      <slot />
    </div>
    <div class="seat-plate__avatar" :class="`seat-plate__avatar--${viewMode}`">
      <slot name="avatar" />
    </div>
    <slot name="animation" />
    <template #popper>
      <slot name="popper" />
    </template>
  </component>
</template>
<style lang="scss" scoped>
.seat-plate {
  display: flex;
  align-items: center;
  cursor: pointer;
  transform: translate(-50%, -50%);
  border: none !important;

  &--desktop {
    &.seat-plate--left {
      flex-direction: row-reverse;
      --seat-plate-padding-left: 10%;
      --seat-plate-padding-right: 0%;
      --seat-plate-avatar-transform: translateX(50%);
    }

    &.seat-plate--right {
      flex-direction: row;
      --seat-plate-padding-left: 0%;
      --seat-plate-padding-right: 10%;
      --seat-plate-avatar-transform: translateX(-50%);
    }
  }

  &--mobile {
    flex-direction: column-reverse;
    --seat-plate-avatar-transform: translateY(10%);
  }

  &--disabled {
    pointer-events: none;
  }

  &__content {
    flex-shrink: 0;
    width: 80%;
    height: 80%;
    border-radius: 8px;

    &--mobile {
      z-index: 1;
    }
  }

  &__avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #40424d;

    flex-shrink: 0;
    background: #171923;
    border-radius: 50%;

    transform: var(--seat-plate-avatar-transform);

    &--desktop {
      width: calc(7.84 * var(--tgw));
      height: calc(7.84 * var(--tgw));
    }

    &--mobile {
      width: calc(14 * var(--tgw));
      height: calc(14 * var(--tgw));
      border: 1px #ffffff66 solid;
      background: #2829301a;
      font-size: 8px;
    }
  }
}
</style>
